import { ContactOrganizer } from '@eb/contact-organizer';
import { Button, STYLE_LINK } from '@eb/eds-button';
import { gettext } from '@eb/i18n';
import isEmpty from 'lodash/isEmpty';
import React, { useState } from 'react';
import { trackContactAction } from '../../tracking/trackContactAction';
import { ContactOrganizerProps } from './ContactOrganizerRoot';

export const ContactOrganizerButton: React.FunctionComponent<ContactOrganizerProps> = (
    props,
) => {
    const [isVisible, setVisible] = useState(false);

    const contactProps = {
        ...props,
        domNodeId: 'event-page',
        isVisible,
        onClose: () => setVisible(false),
    };

    const contactText = isEmpty(props.organizerName)
        ? gettext('Contact the Organizer')
        : gettext('Contact');

    const _onClickHandler = () => {
        trackContactAction(props.eventName);
        setVisible(true);
    };

    return (
        <>
            <Button style={STYLE_LINK} onClick={() => _onClickHandler()}>
                {contactText}
            </Button>
            {isVisible && <ContactOrganizer {...contactProps} />}
        </>
    );
};

export default ContactOrganizerButton;
